import type { FunctionalComponent as FC } from 'vue'

type IProps = {
  value: string
}

export const TimeText: FC<IProps> = (props) => {
  return (
    <div class="flex-y-center gap-x-[5px] text-12 text-font-40 mt-[8px]">
      <svg
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        class="w-[14px] h-[14px]"
      >
        <path
          fill="currentColor"
          d="M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0ZM1.966 8a6.035 6.035 0 1 1 12.069 0 6.035 6.035 0 0 1-12.07 0ZM8 7.517c.133 0 .241.108.241.241V4.38a.483.483 0 1 0-.965 0v3.378c0 .401.324.725.724.725h3.38a.483.483 0 0 0 0-.966H8Z"
        />
      </svg>
      {props.value}
    </div>
  )
}
